<template>
  <div class="about-content">
    <div class="details-top">
      <form action="/" class="logo-container">
        <van-search
          v-model="searchContent"
          right-icon=""
          shape="round"
          placeholder="搜索内容"
          @search="onCourseSearchEnter"
          :clearable="true"
          clear-trigger="always"
          @clear="clearSearchValue"
        >
          <template #left-icon>
            <van-icon name="search" />
          </template>
        </van-search>
      </form>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      class="con-list"
    >
      <div
        class="con-item"
        v-for="(item, index) in searchList"
        :key="index"
        @click="handleClickItems(index)"
      >
        <img
          src="@/assets/images/cartojourney/img20.png"
          v-if="item.isCheck"
          class="icon-item"
          alt=""
        />
        <img
          src="@/assets/images/teacher-task/un-select.png"
          v-else
          class="icon-item"
          alt=""
        />
        <div class="item-con">
          <img :src="item.coverMaterialUrl" class="con-cover" alt="" />
          <div class="con-txt">
            <div class="txt-title">{{ item.name }}</div>
            <div class="txt-tag">讲师: {{item.courseLecturers}}</div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="confirm-btn" @click="handleConfirm">确认选择</div>
  </div>
</template>
<script>
import { debounce } from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
import { selectClassCourse, addClassCourse } from '@/api/grade.js'
const UserProfile = {
  data() {
    return {
      searchContent: '',
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      type: '1',
      load: false,
      searchList: [],
      week: null,
      day: null,
      classId: null,
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  mounted () {
    const { week, day, classId } = this.$route.query
    this.week = week
    this.day = day
    this.classId = classId
  },
  methods: {
    onCourseSearchEnter: debounce(function(e) {
      if (e) {
        this.searchContent = e
      }
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      this.onLoad()
      return false
    }, 500),
    onLoad() {
      if (this.load) {
        return
      }
      this.load = true
      selectClassCourse({
        dataValue: this.searchContent,
        displayType: 1,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        let selectCourse = []
        res.data.list.map((item) => {
          item.isCheck = false
          if (selectCourse && selectCourse.length > 0) {
            selectCourse.map((changeItem) => {
              if (
                item.id === changeItem.courseId ||
                item.id === changeItem.id
              ) {
                item.isCheck = true
              }
            })
          }
        })
        this.searchList = this.searchList.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.searchList.length <= 0) {
          this.isSearch = true
        } else {
          this.isSearch = false
        }
        this.pageNum++
      })
    },
    clearSearchValue(e) {
      this.onCourseSearchEnter()
    },

    handleClickItems(index) {
      this.searchList[index].isCheck = !this.searchList[index].isCheck
    },
    handleConfirm () {
      const list = this.searchList
        .filter(acc => acc.isCheck)
        .map(acc => ({ baseId: acc.id, baseType: 2 }))
      const params = {
        classId: this.classId,
        week: this.week,
        day: this.day,
        classContent: list
      }
      addClassCourse(params).then(res => {
        this.$toast('操作成功')
        return this.$router.go(-1)
      })
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.about-content {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #edf1f4 0%, #f2f7fa 100%);
  padding-top: 64px;
  box-sizing: border-box;

  .details-top {
    width: 100%;
    height: 64px;
    background-color: #fff2e8;
    background-image: url("../../../assets/images/cartojourney/img01.png");
    background-repeat: no-repeat;
    background-size: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .logo-container {
      /deep/ .van-search {
        background-color: transparent;

        .van-search__content {
          background: rgba(255, 255, 255, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.9);
        }
      }
    }
  }

  .con-list {
    padding: 10px 16px;
    box-sizing: border-box;

    .con-item {
      background-color: #fff;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      border-radius: 12px;

      .icon-item {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .item-con {
        display: flex;
        align-items: flex-start;

        .con-cover {
          width: 110px;
          height: 60px;
          object-fit: cover;
          margin-right: 6px;
          min-width: 110px;
          border-radius: 6px;
          overflow: hidden;
        }

        .con-txt {
          font-size: 14px;
          .txt-title {
            color: #000000;
            font-weight: 500;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .txt-tag {
            color: #b1b1b1;
          }
        }
      }
    }
  }

  .confirm-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    font-weight: 500;
    color: #fff;
    background-color: #eb1700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/selectCourse.vue